import { null as zNull } from "zod/v4";

export const disconnectTeamworkCommerceIntegration = {
  name: "disconnectTeamworkCommerceIntegration" as const,
  input: zNull(),
  output: zNull(),
};
